<template>
  <div>
    <!-- banner -->
    <img src="static/img/apply.01d9b741.png" alt="" class="banner" />
    <div class="ExemptReview main-width">
      <!-- 政策匹配报告 -->
      <div class="policy">
        <!-- 政策匹配报告 -->
        <div class="policy_box">
          <h2 class="policy_bg">政策匹配报告</h2>
          <p class="policy_ly">北京卫星制造厂</p>
          <div class="policy_sc">
            <h4>
              本报告生产时间为2022-03-16,你所看到的内容为截至时间点的数据快照
            </h4>
            <h4>
              本报告的数据是我们接收您的委托,根据用户需求基于公开信息挖掘,系统深度学习样本后计算结果,我们没有义务对于报告
            </h4>
            <h4>
              本身的真实性进行分辨或核验,本报告内容不构成我们对任何企业之明示或暗示的观点或保证,报告内容仅供用户参考
            </h4>
          </div>
        </div>
        <!-- 企业基本信息 -->
        <div class="qiye">
          <h3>一、企业基本信息</h3>
          <table class="mailTable" cellspacing="0" cellpadding="0">
            <tr>
              <td class="column" style="font-weight: 900">企业名称</td>
              <td colspan="3">北京卫星制造厂</td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">法定代表人</td>
              <td class="column">刘志国</td>
              <td class="column" style="font-weight: 900">注册资本</td>
              <td class="column">8,000,000.00元</td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">统一社会信用代码</td>
              <td>91110108102105348K</td>
              <td class="column" style="font-weight: 900">企业性质</td>
              <td>股份有限公司</td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">公司行业</td>
              <td class="column">制造业</td>
              <td class="column"></td>
              <td class="column"></td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">注册地址</td>
              <td colspan="3">北京市海淀区中关村南三街18号</td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">通信地址</td>
              <td colspan="3">北京市海淀区中关村南三街18号</td>
            </tr>
            <tr>
              <td class="column" style="font-weight: 900">经营范围</td>
              <td colspan="3">
                计算机软件设计与开发，游戏开发，系统集成，网络工程，企业信息化，网站设计与开发，网页制作，通信系统开发集成，自动化控制系统开发集成，自动化工程，网络技术支持，技术咨询服务，计算机软件，电子产品的销售。
              </td>
            </tr>
          </table>
        </div>
        <!-- 申报匹配概况 -->
        <div class="shenbao">
          <h3>二、申报匹配概况</h3>
          <div class="shenbao_flex">
            <div class="shenbao_flex_fenxi">
              <div class="shenbao_flex_fenxi_icon">
                <img src="static/img/true@2x.183ad022.png" alt="" />
              </div>
              <div class="text">
                <div class="top">
                  <span class="status">分析完成！</span>
                  <span
                    >符合您企业申报的项目共<span style="color: rgb(226, 88, 82)"
                      >2</span
                    >
                    个。
                  </span>
                </div>
              </div>
            </div>
            <div>
              <p class="shenbao_flex_mony">1050.00万元</p>
              <p class="shenbao_flex_yuji">预计最多获得的额度</p>
            </div>
          </div>
          <div class="shenbao_xiangmu">
            <h4 class="shenbao_xiangmu_hr">申报项目</h4>
            <div class="shenbao_xiangmu_table">
              <el-table :data="tableData" style="width: 80%">
                <el-table-column
                  prop="date"
                  label="序号"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="标题"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  label="资金范围"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="bumen"
                  label="主管部门"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="riqi"
                  label="申报日期"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="pipei" label="匹配度">
                  <template slot-scope="scope">
                    <span
                      class="statuColor applying"
                      v-if="scope.row.pipei == 1"
                      >高</span
                    >
                    <span
                      class="statuColor applypass"
                      v-if="scope.row.pipei == 2"
                      >中</span
                    >
                    <span
                      class="statuColor applyreject"
                      v-if="scope.row.pipei == 3"
                    >
                      低
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 申报匹配情况解析 -->
        <div class="shenbao_pipei">
          <h3>三、申报匹配情况解析</h3>
          <div class="shenbao_pipei_flex">
            <h4>3.1 2022年北京市高精尖产业发展资金</h4>
            <h4>匹配度：<span style="color: #4988df">高</span></h4>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">基本信息</h4>
            <table class="mailTable" cellspacing="0" cellpadding="0">
              <tr>
                <td class="column" style="color: #fff">所属区划</td>
                <td>北京市</td>
                <td class="column" style="color: #fff">部门</td>
                <td>北京市经济和信息化局</td>
              </tr>
              <tr>
                <td class="column" style="color: #fff">政策分类</td>
                <td>资金补助</td>
                <td class="column" style="color: #fff">扶持金额</td>
                <td>10,000,000元</td>
              </tr>
              <tr>
                <td class="column" style="color: #fff">申报对象</td>
                <td>企业</td>
                <td class="column" style="color: #fff">受理日期</td>
                <td>2022-01-30至2022-05-21</td>
              </tr>
            </table>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">申报方向</h4>
            <div>
              <el-input
                value="高精尖产业发展资金"
                readonly="readonly"
              ></el-input>
            </div>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">申报条件匹配情况</h4>
            <ul class="shenbao_pipei_jiben_ul">
              <li>
                <i class="el-icon-check"></i>
                <span
                  >1.在北京市依法注册登记的具有独立法人资格的单位，且是商业航天、汽车芯片、智能网联汽车等领域的投保企业；</span
                >
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>2.依法报送统计报表；</span>
              </li>
              <li>
                <i class="el-icon-warning-outline"></i>
                <span>3.通过区科技主管部门备案。</span>
              </li>
            </ul>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">支持内容及标准</h4>
            <ul class="shenbao_pipei_jiben_ul">
              <li>
                1.重点新材料首批次应用示范奖励。对符合《北京市重点新材料首批次应用示范指导目录（2021年版）》（另行发布）中的新材料产品应用示范按照销售额的一定比例分档奖励（其中，先进基础材料、关键战略材料不超过20%，前沿新材料不超过30%），单个产品奖励金额最高不超过500万元，单个企业年度奖励金额不超过1000万元。
              </li>
              <li>
                2.商业航天单发（颗）产品补贴金额不超过500万元，汽车芯片单笔保单补贴金额不超过500万元，智能网联汽车单车每年补贴金额不超过1.5万元，单个企业年度补贴金额不超过1000万元。
              </li>
            </ul>
          </div>
          <div class="shenbao_pipei_flex">
            <h4>3.2 2022年北京市知识产权保险试点</h4>
            <h4>匹配度：<span style="color: #4988df">高</span></h4>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">基本信息</h4>
            <table class="mailTable" cellspacing="0" cellpadding="0">
              <tr>
                <td class="column" style="color: #fff">所属区划</td>
                <td>北京市</td>
                <td class="column" style="color: #fff">部门</td>
                <td>北京市知识产权局</td>
              </tr>
              <tr>
                <td class="column" style="color: #fff">政策分类</td>
                <td>认定奖励</td>
                <td class="column" style="color: #fff">扶持金额</td>
                <td>500,000元</td>
              </tr>
              <tr>
                <td class="column" style="color: #fff">申报对象</td>
                <td>企业</td>
                <td class="column" style="color: #fff">受理日期</td>
                <td>2021-01-19至2022-04-21</td>
              </tr>
            </table>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">申报方向</h4>
            <div>
              <el-input value="知识产权保费补贴" readonly="readonly"></el-input>
            </div>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">申报条件匹配情况</h4>
            <ul class="shenbao_pipei_jiben_ul">
              <li>
                <i class="el-icon-check"></i>
                <span
                  >1.冠军企业包括国家工信部或本市评定的制造业单项冠军示范企业、制造业单项冠军产品企业、制造业单项冠军培育企业，以及符合相关要求的外资隐形冠军企业。
                </span>
              </li>
              <li>
                <i class="el-icon-warning-outline"></i>
                <span
                  >2.
                  重点领域中小微企业包括硬科技中小微企业和十大高精尖产业小微企业，应符合相关要求，属于国家高新技术企业、中关村高新技术企业、北京市知识产权试点示范企业以及本市支持中小企业发展资金和基金支持的企业优先。</span
                >
              </li>
            </ul>
          </div>
          <div class="shenbao_pipei_jiben">
            <h4 class="shenbao_pipei_jiben_h4">支持内容及标准</h4>
            <ul class="shenbao_pipei_jiben_ul">
              <li>
                <p>单项冠军企业保费补贴标准为：</p>
              </li>
              <li style="text-indent: 1em">
                <p>
                  1.首次申报按照保费标准给予100%补贴，第二次申报按照保费标准给予80%补贴，第三次申报按照保费标准给予50%补贴。
                </p>
                <p>
                  2.制造业单项冠军示范企业和符合标准的外资隐形冠军企业每年获得的保费补贴不超过50万元；制造业单项冠军产品企业每年获得的保费补贴不超过30万元；制造业单项冠军培育企业每年获得的保费补贴不超过20万元。
                </p>
              </li>
              <li>
                <p>重点领域中小微企业保费补贴标准为：</p>
              </li>
              <li style="text-indent: 1em">
                <p>
                  1.首次申报按照保费标准给予100%补贴，第二次申报按照保费标准给予90%补贴，第三次申报按照保费标准给予80%补贴。
                </p>
                <p>2.每家企业每年获得的保费补贴不超过20万元。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExemptReview",
  components: {},
  data() {
    return {
      tableData: [
        {
          date: "1",
          name: "2022年北京市高精尖产业发展资金",
          address: "1000.00万元",
          bumen: "北京市经济和信息化局",
          riqi: "2022-01-30",
          pipei: "1",
        },
        {
          date: "2",
          name: "2022年北京市知识产权保险试点",
          address: "50.00万元",
          bumen: "北京市知识产权局",
          riqi: "2022-01-19",
          pipei: "1",
        },
      ],
      options: [
        {
          value: "挂牌企业融资补助",
          label: "挂牌企业融资补助",
        },
      ],
      value: "专精特新中小企业认定",
      options_s: [
        {
          value: "专精特新中小企业认定",
          label: "专精特新中小企业认定",
        },
      ],
      value_s: "挂牌企业融资补助",
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;

  margin: 10px auto 30px;
}
.ExemptReview {
  li {
    list-style: none;
  }

  .policy {
    .policy_bg {
      text-align: center;
    }
    .policy_ly {
      text-align: center;
      font-size: 18px;
    }
    .policy_sc {
      margin-top: 45px;
      margin-left: 300px;
    }
    .qiye {
      margin-left: 300px;
      margin-top: 40px;
      .mailTable {
        width: 80%;
        border-top: 1px solid #e6eaee;
        border-left: 1px solid #e6eaee;
      }
      .mailTable tr td {
        // width: 20px;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        padding: 0 10px;
        border-bottom: 1px solid #e6eaee;
        border-right: 1px solid #e6eaee;
      }
      .mailTable tr td.column {
        // background-color: #eff3f6;
        color: #393c3e;
        width: 15%;
      }
    }
    .shenbao {
      margin-top: 45px;
      margin-left: 300px;
      .shenbao_flex {
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2.5rem 0.625rem;
        background: #f6fafe;
        .shenbao_flex_fenxi {
          display: flex;
          justify-content: center;
          align-items: center;
          .shenbao_flex_fenxi_icon {
            width: 4.125rem;
          }
          .top {
            font-size: 1.3rem;
            font-weight: bold;
            color: #333;
            .status {
              color: #4988df;
            }
          }
          .bottom {
            height: 40px;
            background: #fff;
          }
        }
        .shenbao_flex_mony {
          font-size: 25px;
          color: red;
        }
        .shenbao_flex_yuji {
          font-size: 12px;
        }
      }
      .shenbao_xiangmu {
        .shenbao_xiangmu_hr {
          width: 80%;
          height: 25px;
          border-bottom: 2px solid gray;
        }
        .applying {
          color: rgba(24, 144, 255, 1);
        }
        .applypass {
          color: rgb(170, 154, 7);
        }
        .applyreject {
          color: rgb(231, 19, 19);
        }
      }
    }
    .shenbao_pipei {
      margin-top: 45px;
      margin-left: 300px;
      .shenbao_pipei_flex {
        width: 80%;
        display: flex;
        justify-content: space-between;
        // text-indent: 2em;
      }
      .shenbao_pipei_jiben {
        // text-indent: 3em;
        width: 80%;
        .shenbao_pipei_jiben_h4 {
          height: 30px;
          border-bottom: 3px solid gray;
        }
        .mailTable {
          width: 100%;
          border-top: 1px solid #e6eaee;
          border-left: 1px solid #e6eaee;
        }
        .mailTable tr td {
          // width: 20px;
          height: 35px;
          line-height: 35px;
          box-sizing: border-box;
          padding: 0 10px;
          border-bottom: 1px solid #e6eaee;
          border-right: 1px solid #e6eaee;
        }
        .mailTable tr td.column {
          background-color: #4988df;
          color: #393c3e;
          width: 15%;
        }
        .shenbao_pipei_jiben_ul li {
          margin-bottom: 25px;
          color: gray;
        }
        .shenbao_pipei_jiben_ul li i {
          margin-right: 10px;
        }
        .shenbao_pipei_jiben_ul li .el-icon-check::before {
          color: green;
        }
        .shenbao_pipei_jiben_ul li .el-icon-error::before {
          color: red;
        }
        .shenbao_pipei_jiben_ul li .el-icon-warning-outline::before {
          color: #5cb6ff;
        }
        .shenbao_pipei_jiben_ul li span {
          color: gray;
        }
      }
    }
  }
}
</style>
